// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3FJXh","Label":"Input_Label__18ogp","InputElement":"Input_InputElement__4OH_X","Invalid":"Input_Invalid__2kKtG"};